<template>
  <b-container>
    <custom-header />

    <b-row class="mt-5" v-if="viewMode === 'none'">
      <b-col cols="12">
        <b-btn variant="info" style="min-width: 200px" @click="viewMode='createOrder'">Create Order</b-btn>
      </b-col>
      <b-col cols="12 mt-3">
        <b-btn variant="info" style="min-width: 200px" @click="viewMode='menu'">Menu</b-btn>
      </b-col>
    </b-row>

    <b-row v-if="viewMode === 'createOrder'">
      <b-col cols="6" class="text-left">
        <b-btn class='btn btn-sm btn-warning' @click="cancelOrder()">Cancel Order</b-btn>
      </b-col>
      <b-col cols="12" class="mt-3">
        <b-form class="text-left order-form mx-auto" v-if="selectedPageType === 'new'" @submit="beginOrder">
          <b-form-group label="Event Name:" label-for="input-2">
            <b-form-input
              v-model="order.title"
              required
              placeholder="Enter event name"
              class="w-100"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Event Type:">
            <b-form-select style="width:20em;"
              v-model="order.catering.eventType"
              :options="eventTypeOptions"
              class="w-100"
              required
            ></b-form-select>
          </b-form-group>
          <b-form-group label="# of Guests:">
            <b-form-input style="width:8em;" type="number"
              v-model="order.catering.numberGuests"
              class="w-100"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Event Date:">
            <b-form-datepicker style="width:20em;" v-model="order.catering.eventDate" class="mb-2 w-100" required></b-form-datepicker>
          </b-form-group>
          <div class="text-right">
            <b-button variant="info" type="submit">Begin Order</b-button>
          </div>
        </b-form>


        <b-row v-if="selectedPageType === 'order'" class="text-left">
          <b-col cols="6">
            <h3>Event Details</h3>
            <div>Name: <b>{{ order.title }}</b> </div>
            <div>Type: <b>{{ order.catering.eventType }}</b> <span style="margin-left:2em;"> {{ order.catering.numberGuests }} Guests</span></div>
            <div>Date: <b>{{ order.catering.eventDate }}</b> </div>
            <br>
            <div>
              <b-tabs content-class="mt-3" fill>
                <b-tab v-for="(category, index) in categoryData" :key="index" :title="capitalizeFirstLetter(category.title)">
                  <b-table hover :items="category.items" :fields="itemFields" @row-clicked="selectOrderItems" :tbody-tr-class="rowClass">
                    <template v-slot:cell(title)="data">
                      <div style="font-weight:600;">{{data.item.title}}<span style="font-size:.75em;font-weight:300;font-style:italic">{{' Serves ' + data.item.servings}}</span></div>
                      <div v-if="data.item.description" style="margin-left:.75em;"><span style="white-space:pre-line;">{{data.item.description}}</span></div>
                    </template>

                    <template v-slot:cell(price)="data">
                      {{ parseFloat(data.item.price[priceLevel]).toFixed(2) }}
                    </template>
                  </b-table>
                </b-tab>
              </b-tabs>
            </div>
          </b-col>
          <b-col cols="6">
            <b-row>
              <b-col cols="12">
                <h5>Order Details:</h5>
              </b-col>
              <b-col cols="6">
                <generate-order-pdf :order="order" :priceLevel="priceLevel" />
              </b-col>
              <b-col cols="6" class="text-right">
                Order Total: <span style="font-weight:600;">{{ parseFloat(calculateOrderTotal).toFixed(2) }}</span>
              </b-col>
            </b-row>
            <vue-good-table
              :columns="checkoutItemFields"
              :rows="formattedGroupOrderItems"
              :group-options="{
                enabled: true,
                headerPosition: 'top'
              }"
              :sort-options="{
                enabled: false
              }"
              class="order-details-table"
            >
              <template slot="table-header-row" slot-scope="props">
                <div>
                  <div style="float: left">
                    {{ props.row.label }}
                  </div>
                  <div style="float: right">
                    Servings: {{ getTotalServingByCategory(props.row) }} , Amount: {{ getTotalPriceByCategory(props.row) }}
                  </div>
                </div>
              </template>
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'title'">
                  <span>{{props.row.title}}</span>
                </span>
                <span v-if="props.column.field == 'servings'">
                  <span>{{props.row.qty * (props.row.servings || 1)}}</span>
                </span>
                <span v-if="props.column.field == 'qty'">
                  <span><b-form-input style="width:4.5em;" type="number" v-model="props.row.qty" /></span>
                </span>
                <span v-if="props.column.field == 'price'">
                  <span>{{ getFormattedPrice(props.row) }}</span>
                </span>
                <span v-if="props.column.field == 'action'">
                  <div class="b-trash-icon"><b-icon-trash aria-hidden="true" @click="unSelectOrderItems(props.row)"></b-icon-trash></div>
                </span>
              </template>
            </vue-good-table>
          </b-col>
          <!-- <b-col cols="6" class="">
            <b-btn variant="info" v-if="order && order.items && order.items.length > 0" @click="selectedPageType='checkout'">
              Cart ({{ order.items.length }})
            </b-btn>
          </b-col> -->
        </b-row>
      </b-col>
    </b-row>

    <b-row v-if="viewMode === 'menu'">
      <b-col cols="12" class="text-center">
        <b-btn variant="info" class="btn btn-sm" style="position: absolute; left: 14px; top: 10px;" @click="viewMode='none'">Back to Home</b-btn>
        <h3>Menu</h3>
      </b-col>
      <b-col cols="12 mt-4">
        <b-tabs content-class="mt-3" fill>
          <b-tab v-for="(category, index) in categoryData" :key="index" :title="capitalizeFirstLetter(category.title)">
            <b-table hover :items="category.items" :fields="itemFields" class="text-left">
              <template v-slot:cell(title)="data">
                <div style="font-weight:600;">{{data.item.title}}<span style="font-size:.75em;font-weight:300;font-style:italic">{{' Serves ' + data.item.servings}}</span></div>
                <div v-if="data.item.description" style="margin-left:.5em;"><span style="white-space:pre-line;">{{data.item.description}}</span></div>
              </template>

              <template v-slot:cell(price)="data">
                {{ parseFloat(data.item.price[priceLevel]).toFixed(2) }}
              </template>
            </b-table>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import DAH from '../lib/dataAccessHelpers'
import CustomHeader from '../components/Header.vue';
import VueNumberInput from '@chenfengyuan/vue-number-input';
import CateringService from '@/services/CateringService';
import 'vue-good-table/dist/vue-good-table.css'
import { VueGoodTable } from 'vue-good-table';
import GenerateOrderPdf from '../components/GenerateOrderPdf.vue';

export default {
  name: 'cateringHomeScreen',
  components: { CustomHeader, VueNumberInput, VueGoodTable, GenerateOrderPdf },
  props: {
  },
  data () {
    return {
      viewMode: "none",
      priceLevel:0,
      itemFields: [
        { key: 'title', label: 'Item ' },
        // { key: 'description', label: 'Item Description' },
        // { key: 'itemType', label: 'Item Type', thStyle: {minWidth: 120} },
        { key: 'price', label: 'Price' }
      ],
      checkoutItemFields: [
        { key: 'title', field: 'title', label: 'Item Name' },
        // { key: 'description', label: 'Item Description' },
        // { key: 'itemType', label: 'Item Type' },
        { key: 'servings', field: 'servings', label: '# Servings' },
        { key: 'qty', field: 'qty', label: 'Quantity' },
        { key: 'price', field: 'price', label: 'Total' },
        { key: 'action', field: 'action', label: 'action' }
      ],
      selectedPageType: 'new',
      categoryData: [],
      selectedItems: [],
      order: {
        title: '',
        orderDate: '',
        catering: {
          eventType   : '',
          eventDate   : '',
          numberGuests: 10      // fixme: make 0, this is just a temp filler to save a little time during testing
        },
        items   : [],
        subTotal: 0,
        tax     : 0,
        total   : 0
      },
      eventTypeOptions: []
    }
  },
  computed: {
    formattedGroupOrderItems () {
      let items = [];

      let filterItems = this.order.items.reduce(function (r, a) {
          r[a.category] = r[a.category] || [];
          r[a.category].push(a);
          return r;
      }, Object.create(null));

      Object.keys(filterItems).map((key, item) => {
        items.push({
          mode: 'span',
          label: key,
          html: false,
          children: filterItems[key]
        })
      })
      return items;
    },

    calculateOrderTotal() {
      let order = Object.assign({}, this.order);
      order.subTotal = 0;
      order.total    = 0;
      order.tax      = 0;

      if(order.items.length > 0) { // total Items
        order.items.map((item) => {
          console.log( item );
          if( item.itemType === 'item' ) {
            order.subTotal += item.price[this.priceLevel] * item.qty;
            console.log( this.priceLevel, order.subTotal );
          }
        });
      }

      order.total = parseFloat(order.subTotal + order.tax).toFixed(2);
      console.log( order, order.total );
      this.order = order;
      return order.total;
    }
  },
  async mounted () {
    let eventTypes = await CateringService.getEventTypes();
     let eventTypeOptions = [];
    eventTypes.data.map((val) => {
      eventTypeOptions.push(val.title)
    });
    this.eventTypeOptions = eventTypeOptions;
    this.categoryData = JSON.parse(localStorage.getItem('categories'))
    if( ! this.categoryData ) {
      this.categoryData = await this.getCategories();   // stored to localstorage in the method.
    }
    if(JSON.parse(localStorage.getItem('catering-order'))) {
      this.order = JSON.parse(localStorage.getItem('catering-order'));
    }
  },
  methods: {
    selectOrderItems(item) {
      let selectedItem = null;
      let itemIndex = this.order.items.findIndex((e) => {
        return e.itemNumber == item.itemNumber
      });
      if(itemIndex === -1) {
        let selectedItem = Object.assign({}, item);
        delete selectedItem._id;
        this.updateOrder(selectedItem);
        this.order.items.push(selectedItem);
      }
      console.log('selectedItem - ', selectedItem)
      console.log('selectedItem--- - ', item)
      console.log('categoryData - ', this.categoryData[0].items)
    },
    unSelectOrderItems(item) {
      let selectedItem = null;
      let itemIndex = this.order.items.findIndex((e) => {
        return e.itemNumber == item.itemNumber
      });
      if(itemIndex >= 0) {
        this.order.items.splice(itemIndex, 1);
      }
    },
    getTotalServingByCategory(itemRow) {
      let totalServing = 0;
      itemRow.children.map((item) => {
        totalServing += item.qty * item.servings;
      })
      return totalServing;
    },
    getTotalPriceByCategory(itemRow) {
      let that = this;
      let totalPrice = 0;
      let subTotal = 0;
      let total = 0;
      let tax = 0;
      itemRow.children.map((item) => {
        subTotal += item.price[this.priceLevel] * item.qty;
      })
      totalPrice = parseFloat(subTotal + tax).toFixed(2);
      return totalPrice;
    },
    rowClass(item, type) {
      if (item && type === 'row') {
         let itemIndex = this.order.items.findIndex((e) => {
          return e.itemNumber == item.itemNumber
        });
        if(itemIndex > -1) {
           return 'cater-item-selected'
        } else {
          return null
        }
      } else {
        return null
      }
    },
    async getCategories() {
      return await DAH.getCategories();
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    beginOrder(evt) {
      evt.preventDefault();
      this.order.orderDate = this.order.catering.eventDate;   // since this is where we're placing it on the input.
      this.selectedPageType = 'order';
    },
    cancelOrder() {
      // todo:reset the order stuff here
      this.selectedPageType='new';
      this.resetOrder();
      this.viewMode='none';
    },
    resetOrder() {
      this.order = {
        title: '',
        orderDate: '',
        catering: {
          eventType   : '',
          eventDate   : '',
          numberGuests: 10
        },
        items   : [],
        subTotal: 0,
        tax     : 0,
        total   : 0
      }
      localStorage.removeItem('catering-order');
    },
    checkout() {
    },
    updateOrder(item) {
      let t = this;
      console.log( "updateOrder()");
      item.qty = Math.round(t.order.catering.numberGuests/item.servings) || 1;
      // setTimeout( () => {
      //   t.calculateOrderTotal( t.order );
      // },1)
      localStorage.setItem('catering-order', JSON.stringify(this.order));
    },
    getFormattedPrice(item) {
      // this
      // this.updateOrder(item);
      let index = this.order.items.findIndex((e) => e.itemNumber === item.itemNumber);
      this.order.items[index].qty = item.qty;
      console.log('item - ', this.order)
      let price = item.qty * item.price[this.priceLevel];
      return price.toFixed(2);
    },
    generateReport () {

    }
  },
  watch: {
    order: {
      deep: true,
      handler() {
        // this.calculateOrderTotal(this.order);
      }
    }
  }
}
</script>

<style>
  input.number-input__input {
    width: 9.5rem !important;
  }
  .cater-item-selected {
    background: #eeeeee;
  }
  .b-trash-icon {
    text-align: center;
    font-size: 26px;
  }
  .vgt-row-header {
    text-transform: capitalize;
  }
  .order-details-table {
    max-height: 600px;
    overflow: auto;
  }
  .order-form {
    max-width: 450px;
  }
</style>
